import * as actions from "../actionTypes"

// initial state is no items selected
// each item is:
// {
//    id: job document id
//    label: job name
// }

const initialState = {
  value: [],
}

export default function jobGridSelectedItems(state = initialState, action) {
  switch (action.type) {
    case actions.SET_JOB_GRID_SELECTED_ITEMS: {
      return {
        ...state,
        value: action.payload.value,
      }
    }

    default:
      return state
  }
}
